import api from './api';

export const objectStorageApi = {
  uploadImage: async (image) => {
    const response = await api.postAuth('images/upload', image);
    return response.data;
  },
};
